export default __webpack_public_path__ + "static/media/bell.8b642092.svg";